import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { formatDate, formatToZMW, sumOfArray } from "../../../helpers";
import { FaSpinner } from "react-icons/fa";

const DetailedIncomeStatement = ({ rdata, startDate, endDate }) => {
  const [incomeStatementData, setIncomeStatementData] = useState([]);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [netIncome, setNetIncome] = useState(0);
  const [loading, setLoading] = useState(true)

  const {allData, setAllData} = useOutletContext();

  useEffect(() => {
    const fetchData = () => {
      
      let revenueTotal = 0;
      let expensesTotal = 0;
      
      const dataMap = {}; 

rdata.bills.forEach((res) => {
    const coa = allData.budget?.find((b) => b.id === res.coa_id)?.coa || "Unknown";

    const fromCoa = sumOfArray(
        rdata.journal
            .filter((a) => a.from_coa === res.coa_id)
            .map((entry) => parseFloat(entry.amount))
    );
    const toCoa = sumOfArray(
        rdata.journal
            .filter((a) => a.to_coa === res.coa_id)
            .map((entry) => parseFloat(entry.amount))
    );

    let amu = 0.0
    // if(coa === '157004'){
    //   amu = parseFloat(res.amount) * 0.05
    // }else{
      amu = parseFloat(res.amount)
    // }

    const amount = parseFloat(amu) + fromCoa - toCoa;

    
    const coaRecord = allData.coa?.find(item => item.account === coa);
    const name = coaRecord?.name || "Unknown";
    const type = coaRecord?.type?.toLowerCase().includes("rev") ? "revenue" : "expense";

    if (!dataMap[coa]) {
        dataMap[coa] = { name, amount, type };
    } else {
        dataMap[coa].amount += amount;
    }

    if (type === "revenue") {
        revenueTotal += amount;
    } else {
        expensesTotal += amount;
    }
});

rdata.journal.forEach((journalEntry) => {
    // const boz = rdata.bills?.find(item => item.coa_id === journalEntry.to_coa);
    // const soz = rdata.supplier.filter((a) => a.type == 1)?.find(item => item.coa === journalEntry.to_coa);
    // if (boz || soz) return;

    const coaCode = allData.budget?.find(item => item.id === journalEntry.to_coa)?.coa;
    const amount = parseFloat(journalEntry.amount);
    const coaRecord = allData.coa?.find(item => item.account === coaCode);
    const name = coaRecord?.name || "Unknown";
    const type = coaRecord?.type?.toLowerCase().includes("rev") ? "revenue" : "expense";

   
      if (!dataMap[coaCode]) {
        dataMap[coaCode] = { name, amount, type };
    } else {
        dataMap[coaCode].amount += amount;
    }

    if (type === "revenue") {
        revenueTotal += amount;
    } else {
        expensesTotal += amount;
    }
    

  
});

rdata.supplier
    .filter((a) => a.type == 1 && a.expense == 'None')
    .forEach((res) => {
        const fromCoa = sumOfArray(
            rdata.journal
                .filter((a) => a.from_coa === res.coa)
                .map((entry) => parseFloat(entry.amount))
        );
        const toCoa = sumOfArray(
            rdata.journal
                .filter((a) => a.to_coa === res.coa)
                .map((entry) => parseFloat(entry.amount))
        );

        const coa = allData.budget?.find((b) => b.id === res.coa)?.coa;
      
        if (coa !== undefined) {
            const amount = parseFloat(res.amount) - fromCoa + toCoa;
            const coaRecord = allData.coa?.find(item => item.account === coa);
            const name = coaRecord?.name || "Unknown";
            const type = coaRecord?.type?.toLowerCase().includes("rev") ? "revenue" : "expense";

            if (!dataMap[coa]) {
                dataMap[coa] = { name, amount, type };
            } else {
                dataMap[coa].amount += amount;
            }

            if (type === "revenue") {
                revenueTotal += amount;
            } else {
                expensesTotal += amount;
            }
        }
    });



// Convert dataMap object to array
const data = Object.values(dataMap);


      setIncomeStatementData(data);
      setTotalRevenue(revenueTotal);
      setTotalExpenses(expensesTotal);
      setNetIncome(revenueTotal - expensesTotal);
    };

        if(rdata.bills){
          fetchData();
          setLoading(false)
        }
  }, [rdata]);

  const formatAmount = (amount) => formatToZMW(amount.toFixed(2));

  return (
    <div className="w-full">
      {
        loading?
        <>
          <div className='flex justify-center items-center h-full w-full text-blue-950 text-5xl p-5 m-5 '>
              <FaSpinner size={50} className="spinner"  /> 
            </div>
        </>
        :
        <>
         <div className="container mx-auto p-4">
         <div className='text-center'>
                      <h2 className='font-bold text-2xl'>{allData.council[0]?.name.toUpperCase()}</h2>
                      <h2 className="font-bold text-2xl my-3">{'Income Statement'.toUpperCase()}</h2>
                      <h3 className='text-xl font-bold'>From {formatDate(startDate)} to {formatDate(endDate)}</h3>
                  </div>
        <table id="detailed-income-statement" className="w-full g-table">
          <thead className="bg-blue-950 text-white">
            <tr className="">
              <th className="text-left py-2 px-2">Item</th>
              <th className="text-left py-2 px-2">Amount</th>
            </tr>
          </thead>
          <tbody>
            {/* Render Revenue Section */}
            <tr className="bg-gray-800 text-white font-bold">
              <td className="py-2 px-2">Revenue</td>
              <td className="py-2 px-2"></td>
            </tr>
            {incomeStatementData
              .filter((item) => item.type === "revenue")
              .map((item, index) => (
                <tr key={`revenue-${index}`}>
                  <td>{item.name}</td>
                  <td>{formatAmount(item.amount)}</td>
                </tr>
              ))}
            <tr className="bg-blue-950 text-white">
              <td className="py-2 px-2">Total Revenue</td>
              <td className="py-2 px-2">{formatAmount(totalRevenue)}</td>
            </tr>

            {/* Render Expense Section */}
            <tr className="bg-gray-800 text-white font-bold">
              <td className="py-2 px-2">Expense</td>
              <td className="py-2 px-2"></td>
            </tr>
            {incomeStatementData
              .filter((item) => item.type === "expense")
              .map((item, index) => (
                <tr key={`expense-${index}`}>
                  <td>{item.name}</td>
                  <td>{formatAmount(item.amount)}</td>
                </tr>
              ))}
            <tr className="bg-blue-950 text-white">
              <td className="py-2 px-2">Total Expense</td>
              <td className="py-2 px-2">{formatAmount(totalExpenses)}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th className="text-left">Total Revenue</th>
              <th className="text-left" id="total-revenue">{formatAmount(totalRevenue)}</th>
            </tr>
            <tr className="text-left">
              <th>Total Expenses</th>
              <th id="total-expenses">{formatAmount(totalExpenses)}</th>
            </tr>
            <tr className="text-left">
              <th>Surplus(Deficit)</th>
              <th id="net-income">{formatAmount(netIncome)}</th>
            </tr>
          </tfoot>
        </table>
      </div>
        </>
      }
     
    </div>
  );
};

export default DetailedIncomeStatement;
